<template>
  <div v-if="item" class="content">
    <select name="number" @input="updateProperty('numberOfWorkers', $event.target.value)">
      <option value="">-</option>
      <option v-for="(row, j) in 51" :key="j" :selected="item.numberOfWorkers == j" :value="j">{{ j }}</option>
    </select>
    <input
      style="width: 100%"
      type="text"
      name="text"
      :value="item.comment"
      @input="updateProperty('comment', $event.target.value)"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import debounce from 'debounce';

export default {
  name: 'DiaryEntryCompanyItemEdit',
  data() {
    return {};
  },
  props: ['item', 'entry', 'diaryEntry'],
  methods: {
    ...mapActions(['diaryEntrySetItemProperties']),
    updateProperty: debounce(function (property, newValue) {
      if (this.item[property] !== newValue) {
        var newProperties = {
          diaryEntry: this.diaryEntry,
          diaryEntryItem: this.item,
        };
        newProperties[property] = newValue;
        this.diaryEntrySetItemProperties(newProperties);
      }
    }, 400),
  },
  computed: {
    ...mapGetters([]),
  },
  created: async function () {},
  mounted: async function () {},
  components: {},
};
</script>
<style scoped>
.content {
  display: flex;
  flex-direction: row;
}

input,
select {
  border-radius: 0.5cm;
  border: 1px solid #ccc;
  height: 8mm;
  margin: 2mm 0mm;
  padding-left: 0.5cm;
  display: block;
  color: #ccc;
  background: transparent;
}

input:focus,
select:focus {
  border-color: white;
  border-width: 1px;
  outline: none;
  background: rgba(255, 255, 255, 0.1);
}

option {
  color: black;
  background: transparent;
}
</style>



// WEBPACK FOOTER //
// src/components/diary/DiaryEntryCompanyItemEdit.vue